import React from "react"

export type VectorType = {
    X: number
    Y: number
}
export const isTouchEvent = (
     event: React.MouseEvent<HTMLElement, MouseEvent> | 
     React.TouchEvent<HTMLElement> | 
     TouchEvent |
      MouseEvent): event is React.TouchEvent<HTMLElement> => event.type.includes( "touch" )

export const isMouseEvent = ( 
    event: React.MouseEvent<HTMLElement, MouseEvent> | 
    React.TouchEvent<HTMLElement> | 
    TouchEvent | 
    MouseEvent ): event is React.MouseEvent<HTMLElement, MouseEvent> => !event.type.includes( "touch" )
